'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var React = require('react');
var Panel = require('@narvar/nth-block-panel');
var nthHookTheme = require('@narvar/nth-hook-theme');
var nthKitDynamicLayoutNext = require('@narvar/nth-kit-dynamic-layout-next');
var nthBitHeader = require('@narvar/nth-bit-header');
var TextLink = require('@narvar/nth-bit-text-link');
var Paragraph = require('@narvar/nth-bit-paragraph');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var nthHookSettings = require('@narvar/nth-hook-settings');
var nthHookContextAnalytics = require('@narvar/nth-hook-context-analytics');
var nthHookContextPage = require('@narvar/nth-hook-context-page');
var PrefetchData = require('./PrefetchData.js');
var MoreInformation_module = require('./MoreInformation.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Panel__default = /*#__PURE__*/_interopDefaultLegacy(Panel);
var TextLink__default = /*#__PURE__*/_interopDefaultLegacy(TextLink);
var Paragraph__default = /*#__PURE__*/_interopDefaultLegacy(Paragraph);

const {
  FeatureLayout
} = nthKitDynamicLayoutNext.LayoutTree;
const MoreInformation = ({
  featureName,
  fixedPanelHeight,
  layout = FeatureLayout.PORTRAIT
}) => {
  const {
    state: {
      trackingStatus
    }
  } = nthHookContextPage.usePageContext();
  const {
    linksNoneDefault: linkTextDefaultStyle,
    linksNoneHover: linkTextHoverStyle,
    panelcontainerNoneNone
  } = nthHookTheme.useTheme();
  const {
    borderTopColor,
    borderTopStyle,
    borderTopWidth
  } = panelcontainerNoneNone ?? {}; // Can be undefined or null;

  const {
    moreInformationHeader,
    moreInformationTitle,
    moreInformationText,
    moreInformationLink
  } = nthHookTranslations.useTranslations();
  const {
    moreInformation
  } = nthHookSettings.useSettings();
  const {
    showBlockHeader: showBlockHeaderRaw,
    showLink: showLinkRaw,
    link
  } = moreInformation ?? {};
  const showBlockHeader = typeof showBlockHeaderRaw === 'boolean' ? showBlockHeaderRaw : true;
  const showLink = typeof showLinkRaw === 'boolean' ? showLinkRaw : true;
  const isLandscape = layout === FeatureLayout.LANDSCAPE;
  const logEvent = nthHookContextAnalytics.useAnalyticsPost();
  const baseLogInfo = React.useMemo(() => ({
    eventComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_PACK_MORE_INFORMATION,
    eventFeature: nthHookContextAnalytics.NarvarEventComponents.NTH_PACK_MORE_INFORMATION,
    feature: featureName,
    pageComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_PACK_MORE_INFORMATION
  }), [featureName]);
  React.useEffect(() => {
    logEvent({
      ...baseLogInfo,
      eventType: nthHookContextAnalytics.NarvarEventTypes.COMPONENT_RENDER,
      trackLayout: layout
    });
  }, [baseLogInfo, layout, logEvent]);
  const logMoreInfoLinkClick = () => {
    logEvent({
      ...baseLogInfo,
      clickCategory: nthHookContextAnalytics.NarvarClickSubTypes.EXTERNAL_LINK,
      clickLinkDestinationUrl: link,
      clickLinkLabel: moreInformationLink,
      clickSubType: nthHookContextAnalytics.NarvarClickSubTypes.MORE_INFORMATION_LINK,
      clickType: nthHookContextAnalytics.NarvarClickTypes.OUTGOING,
      eventType: nthHookContextAnalytics.NarvarEventTypes.CLICK
    });
  };
  const homePickupStatus = ['HPUSCHEDULED', 'HPUPICKUPINPROGRESS', 'HPUPICKEDUP', 'HPUEXCEPTION'];
  const homePickupLink = 'https://corp.narvar.com/home-pickup-consumer';
  const isHomePickup = homePickupStatus.includes(trackingStatus ?? '');
  const infoLink = isHomePickup && !link ? homePickupLink : link;
  const hasHeader = showBlockHeader && moreInformationHeader;
  return /*#__PURE__*/React__default["default"].createElement(Panel__default["default"], {
    featureName: featureName,
    header: "",
    fixedPanelHeight: fixedPanelHeight
  }, isLandscape ? /*#__PURE__*/React__default["default"].createElement("div", {
    className: MoreInformation_module["default"].landscapeContainer
  }, hasHeader && /*#__PURE__*/React__default["default"].createElement("div", {
    className: MoreInformation_module["default"].landscapeHeader,
    style: {
      borderRight: `
                  ${borderTopWidth ?? '1px'} 
                  ${borderTopStyle ?? 'solid'} 
                  ${borderTopColor ?? '#CCCCCC'}
                `
    }
  }, /*#__PURE__*/React__default["default"].createElement(nthBitHeader.SmallHeader, {
    as: "h2",
    featureName: featureName
  }, moreInformationHeader)), /*#__PURE__*/React__default["default"].createElement("div", {
    className: MoreInformation_module["default"].landscapeMain,
    style: {
      gridColumn: `span ${hasHeader ? 9 : 10}`,
      paddingLeft: `${hasHeader ? '1.5rem' : 0}`
    }
  }, /*#__PURE__*/React__default["default"].createElement("div", null, /*#__PURE__*/React__default["default"].createElement(nthBitHeader.MediumHeader, {
    as: hasHeader ? 'p' : 'h2',
    featureName: featureName
  }, moreInformationTitle), moreInformationText && /*#__PURE__*/React__default["default"].createElement(Paragraph__default["default"], {
    featureName: featureName,
    containerCustomStyle: {
      margin: '0.75rem 0 0'
    }
  }, moreInformationText))), showLink && moreInformationLink && infoLink && /*#__PURE__*/React__default["default"].createElement("div", {
    className: MoreInformation_module["default"].landscapeLink
  }, /*#__PURE__*/React__default["default"].createElement(TextLink__default["default"], {
    href: infoLink,
    linkStyle: {
      sDefault: {
        ...linkTextDefaultStyle,
        textAlign: 'right'
      },
      sHover: {
        ...linkTextHoverStyle,
        textAlign: 'right'
      }
    },
    onClick: logMoreInfoLinkClick
  }, moreInformationLink))) : /*#__PURE__*/React__default["default"].createElement("div", {
    className: MoreInformation_module["default"].portraitContainer
  }, showBlockHeader && /*#__PURE__*/React__default["default"].createElement(nthBitHeader.SmallHeader, {
    as: "h2",
    containerCustomStyle: {
      marginBottom: '1rem'
    },
    featureName: featureName
  }, moreInformationHeader), /*#__PURE__*/React__default["default"].createElement(nthBitHeader.MediumHeader, {
    as: showBlockHeader ? 'p' : 'h2',
    featureName: featureName
  }, moreInformationTitle), moreInformationText && /*#__PURE__*/React__default["default"].createElement(Paragraph__default["default"], {
    featureName: featureName,
    containerCustomStyle: {
      margin: '0.75rem 0'
    }
  }, moreInformationText), showLink && moreInformationLink && infoLink && /*#__PURE__*/React__default["default"].createElement(TextLink__default["default"], {
    href: infoLink,
    linkStyle: {
      sDefault: linkTextDefaultStyle,
      sHover: linkTextHoverStyle
    },
    onClick: logMoreInfoLinkClick
  }, moreInformationLink)));
};
const MoreInformationWithData = nthHookSettings.withSettingsProvider(nthHookTranslations.withTranslationsProvider(nthHookTheme.withThemeProvider(MoreInformation, {
  themeTokens: ['linksNoneDefault', 'linksNoneHover', 'panelcontainerNoneNone']
}), {
  translationKeys: ['moreInformationHeader', 'moreInformationTitle', 'moreInformationText', 'moreInformationLink']
}), {
  settingsRequested: `
      moreInformation {
        showBlockHeader
        showLink
        link
      }
    `
});
const MoreInformationWithPrefetchedData = ({
  featureName,
  ...props
}) => /*#__PURE__*/React__default["default"].createElement(PrefetchData["default"], {
  featureName: featureName
}, /*#__PURE__*/React__default["default"].createElement(MoreInformationWithData, _extends__default["default"]({
  featureName: featureName
}, props)));

exports["default"] = MoreInformationWithPrefetchedData;
